import React from 'react';

export default function KpiCard({ label, value, sub, icon, color, trend }) {
  const c = color || 'var(--accent)';
  return (
    <div style={{ ...styles.card }}>
      <div style={styles.top}>
        <div style={{ ...styles.icon, background: c + '18', color: c }}>{icon}</div>
        {trend !== undefined && (
          <span style={{ ...styles.trend, color: trend >= 0 ? 'var(--success)' : 'var(--danger)' }}>
            {trend >= 0 ? '▲' : '▼'} {Math.abs(trend).toFixed(1)}%
          </span>
        )}
      </div>
      <div style={{ ...styles.value, color: 'var(--text)' }}>{value}</div>
      <div style={styles.label}>{label}</div>
      {sub && <div style={styles.sub}>{sub}</div>}
      <div style={{ ...styles.bar, background: c }} />
    </div>
  );
}

const styles = {
  card: {
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius)',
    padding: '20px',
    position: 'relative',
    overflow: 'hidden',
    transition: 'transform 0.2s, background 0.25s, border-color 0.25s',
    boxShadow: 'var(--shadow-sm)',
  },
  top:   { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14 },
  icon:  { width: 38, height: 38, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 },
  trend: { fontSize: 11, fontWeight: 700, fontFamily: 'Space Mono, monospace' },
  value: { fontSize: 28, fontWeight: 800, letterSpacing: '-1px', lineHeight: 1 },
  label: { fontSize: 12, color: 'var(--text2)', marginTop: 6, fontWeight: 500 },
  sub:   { fontSize: 11, color: 'var(--text3)', marginTop: 3 },
  bar:   { position: 'absolute', bottom: 0, left: 0, right: 0, height: 2, opacity: 0.6 },
};
